import React from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import NtMarketingPageContainerHeader from "./NtMarketingPageContainerHeader";
import NtMarketingPageContainerFooter from "./NtMarketingPageConainerFooter";

function NtMarketingPageContainer({
  containerStyle,
  children,
  showHeader = true,
  showFooter = true,
  scrollEnabled = true,
}) {
  return (
    <View style={[styles.container, containerStyle]}>
      <ScrollView
        scrollEnabled={scrollEnabled}
        contentContainerStyle={{ flexGrow: 1 }}
      >
        {children}
        {showHeader && <NtMarketingPageContainerHeader />}
        {showFooter && (
          <NtMarketingPageContainerFooter containerStyle={{ marginTop: 30 }} />
        )}
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#040406",
    paddingBottom: 40,
  },
});

export default NtMarketingPageContainer;
